import {React, observer, _} from '@api'
import {usePdfStore} from '@modules/pdf'
import {Image, Link, StyleSheet, Text, View} from "@react-pdf/renderer";

import {buildImageUrl} from '@utils';
import {SpecDefinition} from 'centric-ui-components';
import {Fragment, FunctionComponent} from 'react';
import {styled} from '@pdf'
import { HexPdf } from '.';
import { useStores } from '@modules'

const RootView = styled.View`
  display:flex;
  flex-direction:column;
  padding: 0 4mm;
`

const TitleText = styled.Text`
  font-size: 8pt;
  font-weight: bold;
  margin-top:2mm;
  margin-left:  auto;
  margin-right: auto;
  overflow:hidden;
  text-overflow:ellipsis;
`

export const SpecCardPdf = observer<{ spec, showTitle?: boolean, specTitle?: any, style?: any, textStyle?: any, imageStyle?: any, hexStyle?: any }>(function SpecCardPdf(props) {
  let {spec, specTitle, showTitle, style, textStyle, hexStyle, imageStyle} = props,
    {nav: {urlString, urlFor}} = useStores(),
    pdf = usePdfStore()

  if (!spec) return null

  if (!spec.title) {
    spec = {
      ...spec,
      title: _.trim(spec.name) || '--',
      subtitle: _.trim(spec.description) || '--',
      exId: spec.exId,
      images: spec.images && spec.images.length ? [buildImageUrl(spec.imagesRaw || spec.images, pdf.config.imageSize)] : [],
      imagesRaw: spec.imagesRaw,
      blank: false,
    }
  }

  const {title, images, subtitle, id, hex} = spec
  let type = spec.type ? spec.type.name : spec.__typename

  return (
    <Link src={urlString(urlFor({workspace: type, queryParams: {ws: undefined, itemId: spec.id, path: ''}}))}>
      <RootView style={style}>
        <SpecPdfImage spec={spec}
                      style={{margin: '0 auto'}}
                      imageStyle={imageStyle}
                      hexStyle={hexStyle}/>

        {showTitle && <TitleText style={textStyle}>{title ? _.truncate(title.toString(), {length: 20, omission: '...'}) : '--'}</TitleText>}
        {/* <Text style={productCardStyles.subtitle}>{subtitle ? _.truncate(subtitle.toString(), {length: 20, omission: '...'}) : '--'}</Text> */}
      </RootView>
    </Link>
  )
})

const SpecPdfImageView = styled.View`
  width:0.2cm;
  height:0.2cm;
  flex-grow:0;
  flex-shrink:0;
  margin: 0 auto;
  display:flex;  
  flex-direction: column;
`

const SpecPdfImageImage = styled.Image`
  width: 100%;
  height:100%;
  margin:0 auto;
  object-fit: contain;
`

export const SpecPdfImage: FunctionComponent<{ spec: SpecDefinition, style?, imageStyle?, hexStyle?, placeholderStyle? }> = ({style, imageStyle, hexStyle, placeholderStyle, spec: {hex, images}}) => {
  const image         = _.first(images)
  const isPlaceholder = !image && _.isEmpty(hex)

  return <Fragment>
    <SpecPdfImageView style={{...style}}>
      {image ? <SpecPdfImageImage style={imageStyle} src={image} source={null}/>
             : !_.isEmpty(hex) ? <HexPdf style={hexStyle} hex={hex}/>
                               : <PdfImagePlaceholder />}
    </SpecPdfImageView>
  </Fragment>
}

const ImagePlaceholderView = styled.View`
  width: 100%;
  height:100%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9d9d9d;
  border-radius: 2px;
  padding:2mm;
`

const NoImageText = styled.Text`
  text-align: center;
  font-size: 8pt;
  font-weight: 300;
`

export const PdfImagePlaceholder = () => {
  return (
    <ImagePlaceholderView>
      <NoImageText>No</NoImageText>
      <NoImageText>Image</NoImageText>
    </ImagePlaceholderView>)
}


// WEBPACK FOOTER //
// ./src/modules/pdf/productCard/SpecCardPdf.tsx